import { useMutation } from "@tanstack/react-query";
import { useAuth } from "../../../../Context/AuthContext";
import { getCampaignMessageErrors } from "../api/campaignReportsApi";

export const useCampaignMessageErrors = () => {
  const auth = useAuth();
  const { token } = auth.getSessionData();

  return useMutation({
    mutationFn: async ({ uidCampaign, idCampaignMessage }) => {
      const response = await getCampaignMessageErrors({
        token,
        uidCampaign,
        idCampaignMessage,
      });

      return response.data;
    },
  });
};
